/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sleek_Last_Deer_KissInputs */

const fr_sleek_last_deer_kiss = /** @type {(inputs: Sleek_Last_Deer_KissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter`)
};

/**

* @param {Sleek_Last_Deer_KissInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const sleek_last_deer_kiss = /** @type {((inputs?: Sleek_Last_Deer_KissInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sleek_Last_Deer_KissInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_sleek_last_deer_kiss(inputs)
});